import * as React from "react";
import logoSrc from "./logo-brokerlink.svg";

export const Hestia = (props) => {
  return (
    <img src={logoSrc} alt="Brokerlink" {...props} />
  );
};
